var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { capitalize, iif, removeKeys } from '@pcty/utils';
import { getAutomation, getDebug, useCitrusDebug } from '@citrus/runtime';
import { useTheme } from '@citrus/user';
import { isSize } from '../types';
import { isColor } from '../types';
var VERSION = '4.3.0';
var Icon = function (_a) {
    var _b, _c;
    var automationId = _a.automationId, bold = _a.bold, className = _a.className, color = _a.color, name = _a.name, _d = _a.size, size = _d === void 0 ? 'small' : _d, _e = _a.__TYPE, __TYPE = _e === void 0 ? 'Icon' : _e, other = __rest(_a, ["automationId", "bold", "className", "color", "name", "size", "__TYPE"]);
    var debug = useCitrusDebug();
    var citrus2022 = useTheme().citrus2022;
    var isCitron = citrus2022 !== null && citrus2022 !== void 0 ? citrus2022 : false;
    var getTitle = function () {
        return capitalize(name
            .replace(/(-|bold)/g, ' ')
            .replace(/ {3}/g, ' ')
            .trim());
    };
    var ariaLabel = (_c = (_b = other === null || other === void 0 ? void 0 : other['aria-label']) !== null && _b !== void 0 ? _b : other === null || other === void 0 ? void 0 : other.title) !== null && _c !== void 0 ? _c : getTitle();
    var ariaLabelledBy = other === null || other === void 0 ? void 0 : other['aria-labelledby'];
    other = removeKeys(other, ['aria-label', 'aria-labelledby', 'title']);
    var isBold = bold !== undefined ? bold : isCitron;
    var isColorValue = isColor(color);
    var isSizeValue = isSize(size);
    var classNames = [
        'pcty-icon',
        isBold ? "icon-".concat(name, "-bold") : 'icon-' + name,
        isSizeValue ? 'size-' + size : '',
        isColorValue ? 'pcty-color-' + color : '',
        className ? className : '',
    ]
        .filter(function (x) { return x.length > 0; })
        .join(' ');
    var colorStyle = iif(!isColorValue, { color: color }, undefined);
    var sizeStyle = iif(!isSizeValue, { fontSize: size }, undefined);
    return (React.createElement("i", __assign({}, other, getAutomation(automationId), getDebug(debug, __TYPE, VERSION), (ariaLabelledBy ? { 'aria-labelledby': ariaLabelledBy } : { 'aria-label': ariaLabel }), { className: classNames, style: __assign(__assign({}, colorStyle), sizeStyle) })));
};
Icon.defaultProps = {
    __TYPE: 'Icon',
};
export default Icon;
